const { fetchJSON } = window.BAO.Utils

class StoreSwitcher extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    /* Force redirect - Start */
    if (window.location.href.indexOf('#geo') > -1) {
      return this.forceRedirect()
    }
    /* Force redirect - End */

    /* ?country= in URL check - Start */
    // eslint-disable-next-line compat/compat
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    })
    this.countryParam = params.country

    if (this.countryParam !== null) {
      this.setStorageFromURL(this.countryParam)
    }
    /* ?country= in URL check - End */

    if (this.countryParam !== null) {
      const countryCode = this.countryParam

      this.setupCountrySwitcher(countryCode)
      this.updateShippingLabel(countryCode)
    } else if (!this.noLocationStored) {
      const countryCode = window.localStorage.getItem(this.userLocationName)

      this.setupCountrySwitcher(countryCode)
      this.updateShippingLabel(countryCode)
    } else {
      fetchJSON('/browsing_context_suggestions.json', {
        method: 'GET',
      }).then((res) => {
        const countryCode = res.detected_values.country.handle

        this.setupCountrySwitcher(countryCode)
        this.updateShippingLabel(countryCode)
      })
    }
  }

  forceRedirect () {
    fetchJSON('/browsing_context_suggestions.json', {
      method: 'GET',
    }).then((res) => {
      const userCountry = res.detected_values.country.handle

      let windowPathname = window.location.pathname

      const subdomainFolder = windowPathname.split('/').filter((item) => {
        return item.indexOf('en-') > -1
      })

      if (subdomainFolder) {
        windowPathname = windowPathname
          .replace(subdomainFolder, '')
          .replace('//', '/')
      }

      window.location.href = `${
        this.selectedSites[this.countries[userCountry].site].url
      }${windowPathname}?country=${userCountry}`
    })
  }

  setupListeners () {
    super.setupListeners()

    this.onTriggerClick = this.onTriggerClick.bind(this)
    this.onLinkClick = this.onLinkClick.bind(this)
    this.onConfirmClick = this.onConfirmClick.bind(this)

    this.onDrawerTriggerClick = this.onDrawerTriggerClick.bind(this)
    this.onDrawerLinkClick = this.onDrawerLinkClick.bind(this)
    this.onDrawerConfirmClick = this.onDrawerConfirmClick.bind(this)

    if (this.els?.trigger?.exists) {
      this.els.trigger.elements.forEach((triggerEl) => {
        this.listeners.add(triggerEl, 'click', this.onTriggerClick)
      })
    }

    document.addEventListener('click', this.onLinkClick)

    if (this.els?.confirm?.exists) {
      this.els.confirm.elements.forEach((confirmEl) => {
        this.listeners.add(confirmEl, 'click', this.onConfirmClick)
      })
    }

    if (this.externalEls?.trigger?.exists) {
      this.externalEls.trigger.elements.forEach((triggerEl) => {
        this.listeners.add(triggerEl, 'click', this.onDrawerTriggerClick)
      })
    }

    document.addEventListener('click', this.onDrawerLinkClick)

    if (this.externalEls?.confirm?.exists) {
      this.externalEls.confirm.elements.forEach((confirmEl) => {
        this.listeners.add(confirmEl, 'click', this.onDrawerConfirmClick)
      })
    }
  }

  setStorageFromURL (countryCode) {
    if (this.countries[countryCode].site === this.dataset.store) {
      window.localStorage.setItem(this.userLocationName, countryCode)
    }
  }

  onDrawerConfirmClick () {
    const currentLink = document.querySelector(
      `${this.externalEls?.link?.selector}[aria-current="true"]`,
    )
    if (!currentLink) return

    const href = currentLink.getAttribute('href')
    window.location.href = href
  }

  onDrawerLinkClick (event) {
    const linkSelector = this.externalEls?.link?.selector
    if (!event.target.closest(linkSelector)) return

    event.preventDefault()

    const allLinks = document.querySelectorAll(linkSelector)
    allLinks.forEach((link) => link.removeAttribute('aria-current'))

    const clickedLink = event.target.closest(linkSelector)
    const label = clickedLink.innerHTML

    clickedLink.setAttribute('aria-current', 'true')

    this.externalEls.drawer.element.setAttribute('aria-hidden', 'true')
    this.externalEls.trigger.element.setAttribute('aria-expanded', 'false')
    this.externalEls['trigger-text'].element.innerHTML = label
    this.externalEls.confirm.element.disabled = false
  }

  onDrawerTriggerClick () {
    const currentTriggerState =
      this.externalEls.trigger.element.getAttribute('aria-expanded') === 'true'
    this.externalEls.trigger.element.setAttribute(
      'aria-expanded',
      !currentTriggerState,
    )

    const currentDrawerState =
      this.externalEls.drawer.element.getAttribute('aria-hidden') === 'true'
    this.externalEls.drawer.element.setAttribute(
      'aria-hidden',
      !currentDrawerState,
    )
  }

  onTriggerClick () {
    const currentTriggerState =
      this.els.trigger.element.getAttribute('aria-expanded') === 'true'
    this.els.trigger.element.setAttribute(
      'aria-expanded',
      !currentTriggerState,
    )

    const currentOptionsState =
      this.els.options.element.getAttribute('aria-hidden') === 'true'
    this.els.options.element.setAttribute('aria-hidden', !currentOptionsState)
  }

  onLinkClick (event) {
    const linkSelector = this.els?.link?.selector
    if (!event.target.closest(linkSelector)) return

    event.preventDefault()

    const allLinks = document.querySelectorAll(linkSelector)
    allLinks.forEach((link) => link.removeAttribute('aria-current'))

    const clickedLink = event.target.closest(linkSelector)
    const label = clickedLink.innerHTML

    clickedLink.setAttribute('aria-current', 'true')

    this.els.options.element.setAttribute('aria-hidden', 'true')
    this.els.trigger.element.setAttribute('aria-expanded', 'false')
    this.els['trigger-text'].element.innerHTML = label
  }

  onConfirmClick (event) {
    event.preventDefault()

    const currentLink = document.querySelector(
      `${this.els?.link?.selector}[aria-current="true"]`,
    )
    if (!currentLink) return

    const href = currentLink.getAttribute('href')
    window.location.href = href
  }

  updateShippingLabel (countryCode) {
    const upperCountryCode = countryCode.toUpperCase()

    if (this.countries[upperCountryCode] !== undefined) {
      const name = this.countries[upperCountryCode].name

      if (this.els?.['trigger-text']?.exists) {
        this.els['trigger-text'].elements.forEach((countryEl) => {
          countryEl.innerHTML = `${name}`
        })
      }
    }

    if (this.noLocationStored) return

    if (this.countries[upperCountryCode] !== undefined) {
      const name = this.countries[upperCountryCode].name

      if (this.externalEls?.['trigger-text']?.exists) {
        this.externalEls['trigger-text'].elements.forEach(
          (countryExternalEl) => {
            countryExternalEl.innerHTML = `${name}`
          },
        )
      }

      if (this.externalEls?.['drawer-trigger']?.exists) {
        this.externalEls['drawer-trigger'].elements.forEach(
          (countryExternalEl) => {
            countryExternalEl.innerHTML = `${name}`
          },
        )
      }
    }
  }

  setupCountrySwitcher (countryCode) {
    this.createOptions(countryCode)

    this.identifyKlaviyoUser(countryCode)

    if (this.countries[countryCode].site === this.dataset.store) {
      window.localStorage.setItem(this.userLocationName, countryCode)
    }

    if (!this.noLocationStored) return

    if (this.countryParam !== null) return

    this.setAttribute('aria-hidden', 'false')
    document.body.classList.add('util-SiteOverflowed')
  }

  identifyKlaviyoUser (countryCode) {
    const data = {
      CountryCode: countryCode,
    }

    if (window.theme.klaviyo.email) {
      data.$email = window.theme.klaviyo.email
    }

    if (window.klaviyo) {
      window.klaviyo.identify(data)
    }
  }

  createOptions (countryCode) {
    Object.entries(this.countries).forEach(([key, value]) => {
      const { name, site, currency } = value

      const isCurrentSite = key.toLowerCase() === countryCode.toLowerCase()
      this.els.options.element.innerHTML += this.createModalElement(
        key,
        site,
        isCurrentSite,
        name,
        currency,
      )

      this.externalEls.drawer.element.innerHTML += this.createDrawerElement(
        key,
        site,
        isCurrentSite,
        name,
        currency,
      )
    })
  }

  createModalElement (code, site, isCurrentSite, country) {
    return `<li class="mod-StoreSwitcher_Item">
      <a
        class="mod-StoreSwitcher_Link fz-12_130"
        href="${this.selectedSites[site].url}${this.dataset.pageUrl}?country=${code}"
        aria-current="${isCurrentSite ? 'true' : 'false'}"
        data-store-switcher-el="link"
      >
        ${country}
      </a>
    </li>`
  }

  createDrawerElement (code, site, isCurrentSite, country) {
    return `<li class="drw-StoreSwitcher_Item">
      <a
        class="drw-StoreSwitcher_Link fz-12_130"
        href="${this.selectedSites[site].url}${this.dataset.pageUrl}?country=${code}"
        aria-current="${isCurrentSite ? 'true' : 'false'}"
        data-store-switcher-external-el="link"
      >
        ${country}
      </a>
    </li>`
  }

  get noLocationStored () {
    return (
      window.localStorage.getItem(this.userLocationName) == null ||
      (window.localStorage.getItem(this.userLocationName) === undefined &&
        !window.Shopify.designMode)
    )
  }

  get userLocationName () {
    return 'PP-BAO-localization'
  }

  get isPrivateClient () {
    return this.dataset.privateClient === 'true'
  }

  get isStaging () {
    return this.dataset.staging === 'true'
  }

  get isQa () {
    return this.dataset.qa === 'true'
  }

  get selectedSites () {
    if (this.isStaging) {
      return this.stagingSites
    }
    if (this.isQa) {
      return this.qaSites
    }
    return this.isPrivateClient ? this.pcSites : this.defaultSites
  }

  get defaultSites () {
    return {
      EU: {
        url: 'https://phoebe-philo-eu.myshopify.com',
      },
      ROW: {
        url: 'https://phoebe-philo-row.myshopify.com',
      },
      UK: {
        url: 'https://phoebe-philo-uk.myshopify.com',
      },
      US: {
        url: 'https://phoebe-philo-us.myshopify.com',
      },
    }
  }

  get pcSites () {
    return {
      EU: {
        url: 'https://pc-phoebe-philo-eu.myshopify.com',
      },
      ROW: {
        url: 'https://pc-phoebe-philo-int.myshopify.com',
      },
      UK: {
        url: 'https://pc-phoebe-philo-gb.myshopify.com',
      },
      US: {
        url: 'https://pc-phoebe-philo-us.myshopify.com',
      },
    }
  }

  get stagingSites () {
    return {
      EU: {
        url: 'https://pp-staging-site.myshopify.com',
      },
      ROW: {
        url: 'https://pp-staging-site.myshopify.com',
      },
      UK: {
        url: 'https://pp-staging-site.myshopify.com',
      },
      US: {
        url: 'https://pp-staging-site.myshopify.com',
      },
    }
  }

  get qaSites () {
    return {
      EU: {
        url: 'https://phoebe-philo-qa.myshopify.com',
      },
      ROW: {
        url: 'https://phoebe-philo-qa.myshopify.com',
      },
      UK: {
        url: 'https://phoebe-philo-qa.myshopify.com',
      },
      US: {
        url: 'https://phoebe-philo-qa.myshopify.com',
      },
    }
  }

  get countries () {
    return window.theme.countries
  }
}

if (!customElements.get('store-switcher')) {
  customElements.define('store-switcher', StoreSwitcher)
}
